import { IMAGES } from "../lib/data";

const TILES = [
  { src: IMAGES.deck, alt: "Bavaria 35 deck — open water", span: "md:col-span-2 md:row-span-2" },
  { src: IMAGES.bermudaMoored, alt: "Anchored along Bermuda's pink shoreline" },
  { src: IMAGES.dockyardWithBus, alt: "Mini Bus Tour at Dockyard King's Wharf" },
  { src: IMAGES.horseshoeBay, alt: "Horseshoe Bay — pink sand & turquoise water", span: "md:col-span-2" },
  { src: IMAGES.interior, alt: "Bavaria 35 main salon" },
  { src: IMAGES.dockyardNoBus, alt: "The Royal Naval Dockyard, Bermuda" },
  { src: IMAGES.galley, alt: "Galley with TV" },
  { src: IMAGES.bermudaStreet, alt: "Classic Bermuda pastel streetscape", span: "md:col-span-2" },
  { src: IMAGES.busTour, alt: "Bermuda's iconic pink mini bus" },
  { src: IMAGES.cabin1, alt: "Forward cabin" },
  { src: IMAGES.cocktail, alt: "Signature cocktail" },
  { src: IMAGES.corridor, alt: "Companionway & cabins" },
  { src: IMAGES.cabin2, alt: "Guest cabin", span: "md:col-span-2" },
  { src: IMAGES.breakfast, alt: "Breakfast spread" },
  { src: IMAGES.wine, alt: "House wine pour" },
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="bg-sand">
      <section className="pt-28 pb-12 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="overline mb-5">Gallery</div>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl text-navy leading-[1.02] max-w-4xl">
          Days on the water.
        </h1>
        <p className="mt-6 text-[color:var(--am-muted)] max-w-xl leading-relaxed">
          A visual log of sunset spills, glass surfaces, and long slow lunches
          somewhere off the coast of Bermuda.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[220px] md:auto-rows-[260px] gap-3">
          {TILES.map((t, i) => (
            <div
              key={i}
              className={`img-zoom overflow-hidden bg-[color:var(--am-line)] ${t.span || ""}`}
              data-testid={`gallery-tile-${i}`}
            >
              <img src={t.src} alt={t.alt} loading="lazy" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
